<app-list-load-error [error]="loadingError" (retry)="resetItems()" />
@if (libraryInteractions) {
<div #scrollableContainer class="overflow-y-auto grow basis-0 has-[app-list-items-separator]:scroll-pt-16 px-8"
  appSelectableList #nativeSelection="appSelectableList" appSelectableListLabel="Forms" [appSelectableListReset]="resetSelected"
  [appSelectableListItems]="items" (openSelected)="activateLibrary($event)">
  @if (loading && !items.length) {
    <app-loading-indicator [inPanel]="true">{{ kind === 'folder' ? 'Loading form folders' : 'Loading forms' }}</app-loading-indicator>
  }
  @if (!loading && !loadingError && !items.length && notFoundTemplate) {
    <ng-container [ngTemplateOutlet]="notFoundTemplate" />
  }
  @if (libraryInteractions && !loading && !loadingError && !items.length && !notFoundTemplate) { <app-no-content-stub class="grow h-full" imageSrc="assets/forms-engine/stitch/illustrations/empty-forms.svg" [size]="75"><p class="text-base font-medium text-gray-900 text-center">No forms here yet</p></app-no-content-stub> }
      @for (item of items; track item.data.id) {
        @if (item.data.itemType === 'form') {
          <app-forms-library-card #hubItem class="block" [item]="item.data" [position]="$index"
            [appSelectable]="item.data" [appSelectablePosition]="$index" [appSelectableIdentifier]="item.data.id" [appSelectableListRef]="nativeSelection"
            (open)="itemOpen.emit(item.data.id)" (onDoubleClick)="itemOpen.emit(item.data.id)" />
        }
      }
</div>
<app-list-selection-bar [list]="nativeSelection" />
} @else {
<div #scrollableContainer class="overflow-y-auto grow basis-0 has-[app-list-items-separator]:scroll-pt-16 px-8">
  @if (loading && !items.length) {
    <app-loading-indicator [inPanel]="true">{{ kind === 'folder' ? 'Loading form folders' : 'Loading forms' }}</app-loading-indicator>
  }
  @if (!loading && !loadingError && !items.length && notFoundTemplate) {
    <ng-container [ngTemplateOutlet]="notFoundTemplate" />
  }
  @for (item of items; track item.data.id) {
    @if (kpInteractions) {
      <div
        class="cursor-pointer py-2"
        role="button"
        tabindex="0"
        [attr.aria-label]="'Open ' + item.data.title"
        (appClick)="itemActivate.emit(item.data.id)"
        (appDblClick)="itemOpen.emit(item.data.id)"
        (keydown.enter)="activateKey($event, item.data.id)"
        (keydown.space)="activateKey($event, item.data.id)"
      >
        <app-link-info-deck #hubItem class="block" [item]="item.data" [withActions]="false" [openable]="false" />
      </div>
    } @else {
      <app-link-info-deck #hubItem class="block py-2" [item]="item.data" [withActions]="false" />
    }
  }
</div>
}
@if (!kpInteractions || items.length > 0) {
  <app-pagination2
    [page]="displayedPage"
    [loading]="loading"
    [pageSize]="pageSize"
    [totalItems]="totalCount"
    (refresh)="resetItems()"
    (pageChange)="loadPage($event, true)"
    class="border-t border-border"
  />
}
